"use strict";

exports.__esModule = true;
exports.modernXAxisProps = exports.modernChartProps = exports.MODERN_X_AXIS_HEIGHT = exports.MODERN_CHART_MARGIN = void 0;
/**
 * Geometry of a Recharts time-series chart under the modern UI.
 *
 * The modern axis draws no axis line and no tick lines and sets its labels
 * in 10.5px mono, so the x-axis needs less than Recharts' default 30px. The
 * chart also sits inside a padded card, so it keeps no bottom margin of its
 * own. Together these hand a short chart its plot back: the 150px data-item
 * chart on the Device Details Standard report keeps a plot at least as tall
 * as the one it drew without a card. Under the legacy UI both return nothing,
 * so the charts render as they always did.
 */
var MODERN_X_AXIS_HEIGHT = exports.MODERN_X_AXIS_HEIGHT = 22;
var MODERN_CHART_MARGIN = exports.MODERN_CHART_MARGIN = {
  top: 6,
  right: 5,
  bottom: 0,
  left: 5
};

/** Extra props for a Recharts <XAxis>. */
var modernXAxisProps = exports.modernXAxisProps = function modernXAxisProps(theme) {
  return theme && theme.uiModern ? {
    height: MODERN_X_AXIS_HEIGHT
  } : {};
};

/** Extra props for a Recharts chart root (<LineChart>, <ScatterChart>). */
var modernChartProps = exports.modernChartProps = function modernChartProps(theme) {
  return theme && theme.uiModern ? {
    margin: MODERN_CHART_MARGIN
  } : {};
};